import _ from 'lodash';
import initHelpers from '72cms-ui/helpers';
import envDev from '../config/dev.env';
import envProd from '../config/prod.env';

const env = process.env.NODE_ENV === 'production' ? envProd : envDev;
const helpers = initHelpers(getEnv());

function getEnv() {
    return _.chain(env)
        .toPairs()
        .map(([k, v]) => [k, _.trim(v, '"')])
        .fromPairs()
        .value();
}

export default (path = null) => {
    if (path == 'env') return getEnv();

    return helpers(path);
}



// WEBPACK FOOTER //
// ./src/helpers.js